import { baseQuery } from '../baseQuery';

type RequestPaymentPayload = {
  jobId: number;
  sendEmail: boolean;
  sendSms: boolean;
  secondaryNumber?: string;
};

export const postRequestPayment = async ({ jobId, sendEmail, sendSms, secondaryNumber }: RequestPaymentPayload) => {
  const { data } = await baseQuery('payment-request', {
    type: 'POST',
    body: {
      job_id: jobId,
      send_email: sendEmail,
      send_sms: sendSms,
      send_num: secondaryNumber,
    },
  });

  return data;
};
